/**
 * external dependencies
 */
import * as Sentry from "@sentry/browser";

/**
 * internal dependencies
 */
import useAuth from "./hooks/auth-hooks";
import { SITE_VERSION } from "./types/types";

/**
 * Initializes Sentry
 * 
 * @returns void
 */
const SentyInit = () => {
  const user = useAuth()!;
  if ( !user ) return;
  const { userId, name } = user;

  if ( userId ) {
    Sentry.setUser({
      id: userId,
      username: name
    });
  }

  let sentryDSN = '';
  let sentryEnv = '';
  let sentryRel = SITE_VERSION;

  if ( location.hostname === 'staging-allianceautogasfuelingportal.kinsta.cloud' ) {
    sentryDSN = 'https://33f16d875805d71942d38e1e6d2a09e3@o968107.ingest.sentry.io/4506549112209408';
    sentryEnv = 'development';
  } else {
    sentryDSN = "https://f69528075d784c4aa1d99ea7b84d7cd0@o968107.ingest.sentry.io/5933936";
    sentryEnv = 'production';
  }

  Sentry.init({
    dsn: sentryDSN,
    release: sentryRel,
    environment: sentryEnv,
    integrations: [
      new Sentry.BrowserTracing()
    ],
    tracesSampleRate: 1.0,
  });
}

export default SentyInit;